export default "__VITE_ASSET__BVy9RDWz__"